import React from 'react';

const EventsPage = props => (
  <div className="events page">
    <h1>Events</h1>
  </div>
);

export default EventsPage;


// WEBPACK FOOTER //
// ./src/pages/events.js